import React from "react";
import "./ProfessionalServices.css";
import HomeIcon from "@mui/icons-material/Home";
import ApartmentIcon from "@mui/icons-material/Apartment";
import RvHookupIcon from "@mui/icons-material/RvHookup";
import LandscapeIcon from "@mui/icons-material/Landscape";

export default function ProfessionalServices() {
  const services = [
    {
      icon: <HomeIcon fontSize="large" />,
      title: "Residential Property Appraisals",
      subtitle: "(Single-Family Homes, Condominiums, and Townhomes)",
      description:
        "Independent market value for purchases, sales, PMI removal, or tax questions. We inspect the property, analyze recent comparable sales, HOA dues and amenities if applicable, and adjust for condition, location, and features to deliver a USPAP-compliant report you can trust.",
    },
    {
      icon: <ApartmentIcon fontSize="large" />,
      title: "2 to 4 Unit Multi-Family Appraisals",
      description:
        "Useful for house hackers, investors, and small portfolios. We analyze income potential, market rents, operating costs, and comparable sales to reflect both investor demand and owner-occupant appeal.",
    },
    {
      icon: <RvHookupIcon fontSize="large" />,
      title: "Manufactured Home Appraisals",
      description:
        "These assignments require careful verification of foundation, title elimination (if applicable), and comparable sales. We document HUD tags, condition, and site improvements to support a clear value opinion.",
    },
    {
      icon: <LandscapeIcon fontSize="large" />,
      title: "Vacant Land Appraisals",
      description:
        "Land value is influenced by location, zoning, topography, access, and development potential. We analyze site characteristics, available utilities, and comparable land sales to provide a credible, well-supported valuation for lending, investment, or future development decisions.",
    },
  ];

  return (
    <section className="ProfessionalServices" aria-labelledby="services-title">
      <div className="ProfessionalServices__container">
        <h2 id="services-title" className="ProfessionalServices__heading">
          Professional Appraisal Services
        </h2>

        <div className="ProfessionalServices__grid">
          {services.map((service, index) => (
            <div key={index} className="ProfessionalServices__card">
              <div className="ProfessionalServices__icon">
                {service.icon}
              </div>

              <div className="ProfessionalServices__text-block">
                <h3 className="ProfessionalServices__title">
                  {service.title}
                  {service.subtitle && (
                    <span className="ProfessionalServices__subtitle">
                      {" "}
                      {service.subtitle}
                    </span>
                  )}
                </h3>

                <p className="ProfessionalServices__description">
                  {service.description}
                </p>
              </div>

              {service.includes && service.includes.length > 0 && (
                <div
                  className="ProfessionalServices__includes"
                  aria-label="What's included"
                >
                  <span className="ProfessionalServices__includes-title">
                    Includes
                  </span>
                  <ul className="ProfessionalServices__includes-list">
                    {service.includes.map((item, i) => (
                      <li
                        key={i}
                        className="ProfessionalServices__includes-item"
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}